import { Heading } from "components/Heading";
import { Button } from "newui/components/Button";
import { FiEdit, FiLayers } from "react-icons/fi";
import { cn } from "utils/helpers";
import { RfxQuoteTable } from "../../types/quote.type";

type RfxQuoteHeaderProps = {
	children: React.ReactNode;
	className?: string;
	description?: string;
	hasRevisions?: boolean;
	hasValidationError?: boolean;
	isBeingRevised?: boolean;
	keyValue?: string;
	quote: RfxQuoteTable;
	title?: string;
	onCompareRevisions?: (quote: RfxQuoteTable) => void;
	onOpenReviseQuote?: (quote: RfxQuoteTable) => void;
};

export const RfxQuoteHeader = ({
	title,
	description,
	children,
	className,
	keyValue,
	hasRevisions = false,
	hasValidationError = false,
	isBeingRevised = false,
	quote,
	onCompareRevisions,
	onOpenReviseQuote,
}: RfxQuoteHeaderProps) => {

	const onReviseQuote = () => {
		onOpenReviseQuote && onOpenReviseQuote(quote);
	}

	const onCompare = () => {
		onCompareRevisions && onCompareRevisions(quote);
	}

	return (
		<div
			key={keyValue}
			className={cn(
				"mb-10 rounded-lg border border-solid bg-white p-10 shadow-sm",
				hasValidationError ? "border-2 border-red-500" : "border-[#EAECF0]",
				className
			)}
		>
			<Heading className="text-4xl !text-royal-blue">{quote?.name ?? title}</Heading>
			{description && (
				<p className="mt-3 text-lg text-tertiary-600">{quote?.description ?? description}</p>
			)}
			<div className="flex gap-2 pt-2">
				{isBeingRevised && (
					<Button
						size="xs"
						btntype="primary"
						onClick={onReviseQuote}
						data-testid={`update-quote-btn-${quote.id ?? keyValue}`}
					>
						<FiEdit /><span className="pl-2">Revise Quote</span>
					</Button>
				)}
				{hasRevisions && (
					<Button
						size="xs"
						btntype="secondary"
						onClick={onCompare}
						data-testid="compare-revisions-btn"
					>
						<FiLayers /><span className="pl-2">Compare Revisions</span>
					</Button>
				)}
			</div>
			<div className="my-9 w-full border-b border-[#D0D5DD] shadow-sm"></div>
			{children}
		</div>
	);
};
